export const GLOBAL_FILTER = "Global";
